import * as React from 'react';

import * as styles from './styles.css';

/**
 * Обертка, скрывающая содержимое с экрана, но оставляющая его доступным
 * для экранных читалок и ботов.
 */
export const ScreenReaderOnly: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['sro-content']}>{children}</div>;
};
